module.exports = __webpack_public_path__ + "static/holding-logo-e383d865722d8a2d83f9ab50d0f7417b.png";